import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Avatar,
  Paper,
  Card,
  CardMedia,
  CardContent,
  IconButton,
  Button,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Chip,
  Stack,
} from '@mui/material';
import {
  Person as PersonIcon,
  CalendarToday,
  ChatBubbleOutline,
  Search as SearchIcon,
  ArrowRightAlt,
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
  PlayArrow,
} from '@mui/icons-material';
import BlogSidebar from './BlogSidebar';
import HeroSection from './HeroSection';
import PostCommentForm from './PostCommentForm';

export default function BlogDetails() {
  const popular = [
    { title: 'Budget issues force the our to become', date: '24th March 2024' },
    { title: 'The best products that shape fashion', date: '25th March 2024' },
    { title: 'The best products that shape fashion', date: '26th March 2024' },
  ];

  const categories = [
    'Burger',
    'Fried Chiken',
    'French Fries',
    'Hot Pizzas',
    'Sandwich',
  ];

  const tags = ['Burger', 'Hot Dog', 'French Fries', 'Chiken', 'Pasta', 'Sandwich'];

  const comments = [
    { name: 'Rosalina Kelian', date: '19th May 2024', text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' },
    { name: 'Arista Williamson', date: '21th Feb 2024', text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' },
    { name: 'Salman Ahmed', date: '29th Jan 2021', text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' },
  ];

  return (
    <Box sx={{ bgcolor: 'background.default',  minHeight: '100vh' }}>
      <HeroSection title="BLOG DETAILS" description="Read our latest posts and insights" />
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Main content */}
          <Grid item xs={12} md={8}>
            <Typography variant="h3" sx={{ fontWeight: 800, mb: 2, textTransform: 'uppercase' }}>
              Quick Cravings: Unraveling Fast Food Delights
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
              <Avatar sx={{ width: 56, height: 56 }}>
                <PersonIcon />
              </Avatar>
              <Box>
                <Typography sx={{ fontWeight: 700 }}>Shikhon .Ha</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  <CalendarToday fontSize="small" /> 4th February 2024 • <ChatBubbleOutline fontSize="small" /> 15 Comments
                </Typography>
              </Box>
            </Box>

            <Typography paragraph color="text.secondary">
              There are many variations of passages of Lorem Ipsum available, but majority have suffered Lorem
              haca ullamcorper donec ante habi believable. If you are going to use a passage of Lorem Ipsum cibo
              mundi ea duo donec imperdiet eturpis varius per a augue magna hac. dolor sit amet, teration in some form.
            </Typography>

            <Card sx={{ borderRadius: 2, overflow: 'hidden', mb: 3 }}>
              <CardMedia component="img" image="/assets/images/post-4.jpg" alt="post image" sx={{ height: 360, objectFit: 'cover' }} />
              <CardContent>
                <Typography variant="h6" color="text.secondary">
                  When Food is a Love Language Food is a powerful way to show love. That's especially true in many Asian American and Pacific Islander (AAPI) cultures.
                </Typography>
              </CardContent>
            </Card>

            {/* YouTube Video Section */}
            <Card sx={{ borderRadius: 2, overflow: 'hidden', mb: 3 }}>
              <Box sx={{ position: 'relative', pb: '56.25%', height: 0, overflow: 'hidden' }}>
                <iframe
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    border: 'none'
                  }}
                  src="https://www.youtube.com/embed/oAm3TYN83fw"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </Box>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Watch Our Cooking Tutorial
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Learn how to prepare delicious recipes with step-by-step instructions from our expert chefs.
                </Typography>
              </CardContent>
            </Card>

            <Typography paragraph>
              This shortage is being seen in both the airline and the cargo industries. With such a small pool of applicants to choose from,
              those two sectors are battling to get the most qualified available candidates. Many pilots are increasingly being wooed to get
              behind the controls of passenger planes over cargo flights—frankly, it's tough to compete with jobs perks like fixed schedules and free flights for your family across the world.
            </Typography>

            <Paper sx={{ bgcolor: '#0b7a39', color: 'white', p: 4, borderRadius: 2, mb: 3 }}>
              <Typography variant="h5" align="center" sx={{ fontWeight: 600 }}>
                Your time is limited, so don't waste it living someone else's life. Don't be trapped by dogma – which is living with the results
              </Typography>
            </Paper>

            <Typography paragraph>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </Typography>

            {/* Comments */}
            <Box sx={{ mt: 6 }}>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>03 Comments</Typography>
              <List>
                {comments.map((c, i) => (
                  <Box key={i} sx={{ mb: 2 }}>
                    <ListItem alignItems="flex-start" sx={{ p: 0 }}>
                      <ListItemAvatar>
                        <Avatar sx={{ width: 64, height: 64 }}>{c.name.charAt(0)}</Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={<Typography sx={{ fontWeight: 700 }}>{c.name}</Typography>}
                        secondary={
                          <>
                            <Typography variant="caption" color="primary">{c.date}</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>{c.text}</Typography>
                          </>
                        }
                      />
                      <Button variant="outlined" sx={{ textTransform: 'none' }}>Reply</Button>
                    </ListItem>
                    <Divider sx={{ my: 2 }} />
                  </Box>
                ))}
              </List>

              <PostCommentForm onSubmit={(values) => {
                console.log('Comment submitted:', values);
                // Handle comment submission here
              }} />
            </Box>
          </Grid>

          {/* Sidebar (shared) */}
          <BlogSidebar />
          </Grid>
      </Container>
    </Box>
  );
}
